import { render, staticRenderFns } from "./PannelloManutenzioni.vue?vue&type=template&id=a5e297b2&scoped=true&lang=pug&"
import script from "./PannelloManutenzioni.vue?vue&type=script&lang=ts&"
export * from "./PannelloManutenzioni.vue?vue&type=script&lang=ts&"
import style0 from "./PannelloManutenzioni.vue?vue&type=style&index=0&id=a5e297b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e297b2",
  null
  
)

export default component.exports